var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareModalMs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#paint0_linear_1098_8621)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1098_8621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 13C20.205 13 13 19.8086 13 29.005C13 33.8153 14.9714 37.972 18.1819 40.8431C18.4514 41.0844 18.6141 41.4223 18.6251 41.7839L18.715 44.7189C18.7437 45.6552 19.7107 46.2643 20.5674 45.8861L23.8424 44.4404C24.12 44.3179 24.4311 44.2952 24.7237 44.3757C26.2287 44.7895 27.8304 45.0099 29.4999 45.0099C38.7948 45.0099 45.9999 38.2014 45.9999 29.0049C45.9999 19.8085 38.7949 13 29.5 13Z",
    fill: "url(#paint1_radial_1098_8621)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5917 33.686L24.4386 25.9964C25.2096 24.7731 26.8606 24.4685 28.0174 25.3361L31.8723 28.2273C32.226 28.4926 32.7127 28.4912 33.0649 28.2239L38.2712 24.2726C38.9662 23.7453 39.8732 24.5769 39.4082 25.3149L34.5613 33.0046C33.7903 34.2279 32.1393 34.5325 30.9825 33.6649L27.1275 30.7736C26.7738 30.5084 26.2871 30.5098 25.935 30.7771L20.7286 34.7283C20.0337 35.2556 19.1266 34.424 19.5917 33.686Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1098_8621",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1098_8621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3551 45.5993) scale(35.9391 35.939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9348,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1098_8621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareModalMs);
export default __webpack_public_path__ + "static/media/share-modal-ms.28455eed23a89eb3a53da16c3afc3475.svg";
export { ForwardRef as ReactComponent };